export default "__VITE_ASSET__b18dd055__"